import React, {useEffect} from 'react';
import {Typography, Tooltip, CircularProgress} from '@mui/material';
import {useLazyQuery} from '@apollo/client';

import {LOOKUP_SESSION_WITH_SESSION_RECORDING} from '../../queries/GraphQLQueries';
import ZoomMeetingChip from '../common/ZoomMeetingChip';

const NO_ZOOM_LINK_MESSAGE = "No link available";

const tooltipStyles = {
    "& .MuiTooltip-tooltip": {
        maxWidth: "21.875rem",
        whiteSpace: "normal",
        borderRadius: '1.125rem',
    }
};

const poppperStyles = {
    modifiers: [
        {
            name: "preventOverflow",
            options: {
                boundary: "viewport",
            },
        },
    ],
    sx: tooltipStyles,
};

const zoomMeetingIdStyle = {
    fontSize: '0.875rem',
};

const RenderRecordingComponent = ({sessionId}) => {
    const [lookupSession, {
        loading,
        data
    }] = useLazyQuery(LOOKUP_SESSION_WITH_SESSION_RECORDING, {fetchPolicy: 'network-only'});

    useEffect(() => {
        if (sessionId) {
            lookupSession({variables: {sessionId}});
        }
    }, [sessionId, lookupSession]);

    const zoomMeetingUrl = data?.sessionInfo?.zoomMeetingUrl;
    const zoomMeetingId = zoomMeetingUrl ? zoomMeetingUrl.split('/').pop() : NO_ZOOM_LINK_MESSAGE;

    return <>
        {
          !zoomMeetingUrl
          &&
          <Typography
            variant="body2"
            sx={{fontSize: '0.875rem',}}>
              {zoomMeetingId}
          </Typography>
        }
        {
          zoomMeetingUrl
          &&
          <Tooltip
            title={
                loading
                  ?
                  <CircularProgress size={20} sx={{color: "white"}}/>
                  :
                  <ZoomMeetingChip zoomMeetingUrl={zoomMeetingUrl} showLabelInline={true}/>
            }
            disableFocusListener
            disableTouchListener
            PopperProps={poppperStyles}>
              <Typography variant="body2" sx={zoomMeetingIdStyle}>{zoomMeetingId}</Typography>
          </Tooltip>
        }
    </>;
};

export default RenderRecordingComponent;